import { render, staticRenderFns } from "./SimpleCV.html?vue&type=template&id=7fc46971&scoped=true&"
import script from "./SimpleCV.vue?vue&type=script&lang=js&"
export * from "./SimpleCV.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCV.scss?vue&type=style&index=0&id=7fc46971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc46971",
  null
  
)

export default component.exports